'use client';

import React, { createContext, useContext, useState, useEffect } from 'react';

const CONSENT_KEY = 'identio-cookie-consent';

const ConsentContext = createContext({
  consent: null,
  setConsent: () => {},
  hasDecided: false,
});

export function ConsentProvider({ children }) {
  const [consent, setConsentState] = useState(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    try {
      const stored = window.localStorage.getItem(CONSENT_KEY);
      if (stored === 'accepted' || stored === 'declined') {
        setConsentState(stored === 'accepted');
      }
    } catch (e) {
      // localStorage not available
    }
    setMounted(true);
  }, []);

  const setConsent = (accepted) => {
    setConsentState(accepted);
    try {
      window.localStorage.setItem(CONSENT_KEY, accepted ? 'accepted' : 'declined');
    } catch (e) {
      // ignore
    }
  };

  const hasDecided = consent !== null;
  const value = { consent, setConsent, hasDecided, mounted };

  return (
    <ConsentContext.Provider value={value}>
      {children}
    </ConsentContext.Provider>
  );
}

export function useConsent() {
  const context = useContext(ConsentContext);
  if (!context) {
    return {
      consent: null,
      setConsent: () => {},
      hasDecided: false,
      mounted: true,
    };
  }
  return context;
}
